import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class YaLocationService {
  constructor(private http: HttpClient) {}

  getLocationNameByCoords(coords: number[]) {
    return this.http.get(`https://geocode-maps.yandex.ru/1.x/?apikey=79e49df7-46f2-4f3e-92b2-ea15b84f7aee&format=json&geocode=${coords.join(',')}&lang=en-US`);
  }
}
